import { render } from "./ShowClientSkuMaster.vue?vue&type=template&id=48b5640c"
import script from "./ShowClientSkuMaster.vue?vue&type=script&lang=js"
export * from "./ShowClientSkuMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__